/*
    bf_const.ts
    Copyright (c) 2013-present Human Cube Inc.
    Constant values for BF turn code.
*/

const BF: any = {};

//======================== Map Constants ======================

BF.MAP_FLAG_LOCKED =            1;  // Map should not be overwritten.  Already used for a game.
BF.MAP_FLAG_CAN_SHOW_AS_BOARD = 2;
BF.MAP_FLAG_CAN_SHOW_AS_GLOBE = 4;
BF.MAP_FLAG_CAN_X_PAN_BOARD =   8;
BF.MAP_FLAG_CAN_Y_PAN_BOARD =  16;
BF.MAP_FLAG_BITMAP =           32;  // Bitmap image based map (an external raw ubyte file).
BF.MAP_FLAG_HEXMAP =           64;  // Hex based map (string of two digit hex values).
BF.MAP_FLAG_RAWMAP =          128;  // Raw pixel values based map (string of characters valued 0 to 250).

BF.ZONE_FLAG_LAND_ZONE =  1;
BF.ZONE_FLAG_WATER_ZONE = 2;

BF.MAX_ZONES = 250; // This is locked at 250 because =
                    // We are making the assumption that we will never use bitmaps above 8 bit;
                    // it is not worth it; and we have now implemented things that assume as much.
                    // Colour 0 is used for borders for land to land and land to water.
                    // Colour 255 is used for borders for water to water; these do not have a
                    // shore line rendered onto them.
          					// Colour values 251;252;253 and 254 are now reserved for future use (like
                    // maybe a canal illustrator or something).
					          // So land and water zones are signified by colours 1 through 250.

BF.MAX_BORDERS = 16;   // This is 16 land borders and 16 water borders.

BF.MAX_NATION_NAME = 23;

BF.MIN_HEX_XS = 2;
BF.MAX_HEX_XS = 100;
BF.MIN_HEX_YS = 2;
BF.MAX_HEX_YS = 100;

BF.WORLD_WIDTH = 8192;  // 0 (top or left) to 8191 (bottom or right) for both X and Y coordinates.
                        // Important to keep it an even power of 2.
                        // 8192 was chosen for how it fits in the numerical string representation.
BF.WORLD_HEIGHT = 8192; // Must be the same as WORLD_WIDTH.

BF.MAX_MAP_NAME = 47;
BF.MAX_MAP_DESCRIPTION = 999;

//===================== Scenario Constants =======================

BF.MAX_SCENARIO_NAME = 47;
BF.MAX_SCENARIO_DESCRIPTION = 999;

//====================== Force Constants =========================

BF.MAX_FORCE_TYPES = 30;  // A maximum of 30 force types in a force set (as a bitmask is used).

BF.MAX_FORCES = 1200;  // Maximum number of forces of all players in the game.

    // Important; if you adjust the FORCE_FLAGS_*; need to update the bf_force.js fixtures.!!!
BF.FORCE_FLAG_STARTS_ON_LAND = 		           1;
BF.FORCE_FLAG_STARTS_ON_WATER =              2;
BF.FORCE_FLAG_CAN_MOVE_ON_LAND = 	   	       4;
BF.FORCE_FLAG_CAN_MOVE_ON_WATER =  	         8;

	// One of FORCETYPEFLAG_ISAIRONLYTARGET and FORCETYPEFLAG_ISSURFACEONLYTARGET may be set; but
	// not both. If neither of FORCETYPEFLAG_ISAIRONLYTARGET and FORCETYPEFLAG_ISSURFACEONLYTARGET
	// is set; then the force is indestructable =
BF.FORCE_FLAG_IS_SURFACE_ONLY_TARGET =       16;
BF.FORCE_FLAG_IS_AIR_ONLY_TARGET =		       32;

BF.FORCE_FLAG_BLOCKS_SURFACE =			         64;
BF.FORCE_FLAG_BLOCKS_AIR =				          128;
BF.FORCE_FLAG_CAN_BE_BLOCKED_BY_SURFACE =   256;
BF.FORCE_FLAG_CAN_BE_BLOCKED_BY_AIR =	      512;
BF.FORCE_FLAG_REQUIRES_PRODUCTION =	       1024; // Can only be created via a production force.

BF.FORCE_FLAG_HITS_ONLY_SURFACE_TARGETS =  2048; // Can only be set if FORCETYPEFLAG_HITSONLYAIRTARGETS is not.
BF.FORCE_FLAG_HITS_ONLY_AIR_TARGETS =      4096; // Can only be set if FORCETYPEFLAG_HITSONLYSURFACETARGETS is not.

BF.FORCE_FLAG_MUST_LAND_FRIENDLY =	       8192; // Must land at the end of turn at a friendly
                                                   // land zone (or friendly carrier if
                                                   // carrierSpace >= 0) or crash.
BF.FORCE_FLAG_MUST_LAND_ANY =             16384; // Must land on any land zone (or friendly
                                                   // carrier if carrierSpace >= 0) or crash.

BF.FORCE_FLAG_ONESHOTPERTARGET =          32768; // Gets one shot per opponent force, odds
                                                   // based on defence or attack odds, and the
                                                   // FORCE_FLAG_HITS_ONLY_SURFACE_TARGETS and
                                                   // FORCE_FLAG_HITS_ONLY_AIR_TARGETS for
                                                   // target count.

BF.FORCE_FLAG_CAN_HOLD =                  65536; // Prevents a zone from takeover.
BF.FORCE_FLAG_CAN_CLAIM =                131072; // Can claim new territory.
BF.FORCE_FLAG_CAN_MOVE_AFTER_UNLOADING = 262144; // If it is a transport; it can move after
                                                      // unloading.
BF.FORCE_FLAG_LOAD_SAME_ZONE =           524288; // Loads only from same zone; if not set then
                                                      // loads only from neighbouring zones.
BF.FORCE_FLAG_UNLOAD_SAME_ZONE =        1048576; // Unloads only into same zone; if not set
                                                      // then unloads only into neighbouring zones.
BF.FORCE_FLAG_CAN_LOAD_WHEN_BLOCKED =   2097152; // If it is a transport; it can load cargo
                                                      // even if itself is currently blocked.
BF.FORCE_FLAG_CAN_UNLOAD_WHEN_BLOCKED = 4194304; // If it is a transport; it can unload cargo
                                                      // even if itself is currently blocked.
BF.FORCE_FLAG_CAPITAL_PROD_UNLIMITED =  8388608; // Unlimited production ability if located at
                                                      // a capital.
BF.FORCE_FLAG_PROD_SCALE_ZONE_INCOME = 16777216; // Production ability multiplied by zone income.
BF.FORCE_FLAG_CAN_PRODUCE_NEIGHBOUR =  33554432; // If a producer; it is able to produce different
                                                      // starting type forces in an appropriate
                                                      // neighbouring zone.  Like a land factory
                                                      // producing navy in a bordering water zone.
BF.FORCE_FLAG_PROD_MAX_ONE_PER_ZONE =  67108864; // Max of one is allowed to be built in a zone.

BF.FORCE_FLAG_OWNED_BY_ZONE_OWNER =   134217728; // Whomever owns the zone this force is in,
                                                      // owns this force (eg: factory).
BF.FORCE_FLAG_TERMINATES_IF_ATTACKED = 268435456; // If involved in combat of any type, it
                                                       // will be automatically destroyed.                                                      
BF.FORCE_FLAG_TERMINATES_IF_MOVED =    536870912; // If moved, it will be automatically
                                                  // destroyed during combat stage.

BF.FORCE_FLAG_DESTROYS_ALL =          1073741824; // Destroys all forces in zone, friendly and foe.
                                                  // Used for Nuke ICBM.


// Indexes into force data structure for certain attributes =
BF.FORCE_INDEX_ID =           0;
BF.FORCE_INDEX_TYPE =         1;
BF.FORCE_INDEX_ZONE =         2;
BF.FORCE_INDEX_ZONE_PREV =    3;
BF.FORCE_INDEX_ZONE_RETREAT = 4;
BF.FORCE_INDEX_MOVE_POINTS =  5;
BF.FORCE_INDEX_LOAD_POINTS =  6;
BF.FORCE_INDEX_LIFT_POINTS =  7;
BF.FORCE_INDEX_X =            8;
BF.FORCE_INDEX_Y =            9;
BF.FORCE_INDEX_X_PREV =      10;
BF.FORCE_INDEX_Y_PREV =      11;


BF.FORCE_MAX_NAME =  		  16;  // Might have to make bigger later...
BF.FORCE_MAX_DESCRIPTION = 1000;

BF.FORCE_MAX_MOVES = 8;	// Must be large enough to allow for transport moving and also
                              // loading and unloading since loading and unloading are stored
                              // as a move on transports move data.

// Normal zone id location is > 0; or if <= 0 then it is =
BF.FORCE_ZONE_PRODUCED =   0;
BF.FORCE_ZONE_DESTROYED = -1;
BF.FORCE_ZONE_CRASH =     -2;
BF.FORCE_ZONE_SPLASH =    -3;
        // -4 through -9 available for future use.
BF.FORCE_ZONE_CARGO =    -10;  // Force zone id value for being cargo minus transport force ID.


//================================ Game Constants ==============================

BF.MAX_GAME_NAME = 47;


BF.GAME_STATE_UNKNOWN =        0;
BF.GAME_STATE_HIDDEN =         1;     // Not visible to clients.
BF.GAME_STATE_PREREGISTERING = 2;     // Visible to clients but not yet available for registration.
BF.GAME_STATE_REGISTERING =    3;     // Registering.
BF.GAME_STATE_STARTING =       4;
BF.GAME_STATE_STARTED =        5;
BF.GAME_STATE_FINISHED =       6;
BF.GAME_STATE_ERROR =          7;
BF.GAME_STATE_CANCELLED =      8;
BF.GAME_STATE_EXPIRED =        9;

BF.GAME_STATE_STRING = [
  'Unknown', 'Hidden', 'Preregistering', 'Registering', 'Starting', 'Started',
  'Finished', 'Error', 'Canceled', 'Expired',
];

BF.GAME_FLAG_LOCKED =     				       1;  // Should not be saved over.  Probably already used
                                             // for a game.  Used in scenarios to prevent overwrite.
BF.GAME_FLAG_TEST_RUN = 		             2;  // Test run; do not increment games played count;
                                             // GAME_FLAG_DO_NOT_SCORE should also be set.
BF.GAME_FLAG_SOLO_GAME =                 4;  // Single human only.
BF.GAME_FLAG_RANDOM_TEAM_ASSIGNMENT =    8;  // Players are assigned to teams randomly.
BF.GAME_FLAG_CAN_CHOOSE_PLAYER_INDEX =  16;  // Players can choose their player index; if set
                                             // this takes precedence over the
                                             // GAME_FLAG_RANDOM_TEAM_ASSIGNMENT option.
BF.GAME_FLAG_DO_NOT_SCORE =             32;  // Game will not affect the player ranking scores.

BF.GAME_FLAG_FACTORY_AT_CAPITAL =       64;  // Automatically add a factory at each players captial.
BF.GAME_FLAG_PREMIUM_MEMBERS_ONLY =    128;  // Only premium or better membership players can join.
BF.GAME_FLAG_EXTREME_MEMBERS_ONLY =    256;  // Only extreme or better membership players can join.
BF.GAME_FLAG_LOSE_CAPITAL_LOSE =       512;  // If a player loses their capital; they are
                                             // immediately eliminated from the game.
BF.GAME_FLAG_MUST_RECAPTURE_CAPITAL = 1024;  // If a player has their capital occupied by an
                                             // opponent for two turns in a row; they are
                                             // immediately eliminated from the game.

BF.GAME_FLAG_AUTORESPAWN =            2048; // When this game fills up; automatically create a
                                            // new one of the same configuration.

BF.GAME_FLAG_START_UNBLOCKED =    	  4096; // Rule variation =  Each turn; all forces start
                                            // unblocked. (implemented; but not yet tested.)

BF.GAME_FLAG_PRIVATE =                8192; // Private game.  PIN required.

BF.GAME_FLAG_CLIENT_CALCULATED =     16384; // Not a server game. All turn calculations are done on
                                            // the client.

	/*
	// TODO =
	GAME_FLAG_SECRET_MISSION =      8192;  // Secret Mission game (win game by elimating a preselected player).
	// TODO =
	GAME_FLAG_TOURNAMENT =         16384;  // Tournament game.
	// TODO =
	GAME_FLAG_BOUNTY_HUNTER =      32768;  // Gain points by owning the capital of a player when that player is eliminated.
	*/


BF.PICKING_ORDER_NO_PICKING = 	  0;
BF.PICKING_ORDER_DISTRIBUTED =    1;   // Default.
BF.PICKING_ORDER_123321321 =      2;
BF.PICKING_ORDER_123123123 = 	    3;
BF.PICKING_ORDER_AUTO_123321321 = 4;
BF.PICKING_ORDER_AUTO_123123123 = 5;
BF.PICKING_ORDER_SCATTERED =      6;

BF.GAME_MIN_TURN_TIME = 10*60;         // 10 Minutes.
BF.GAME_MAX_TURN_TIME = 14*24*60*60;   // 14 Days.
BF.GAME_DEFAULT_TURN_TIME = 25*60*60;  // 25 Hours.

BF.GAME_MIN_DURATION = 3*60*60;       // 3 Hours.
BF.GAME_MAX_DURATION = 365*24*60*60;  // 3 Years.

BF.GAME_MIN_TURNS = 6;
BF.GAME_MAX_TURNS = 10000;

//===================== Turn Constants =======================

BF.TURN_PREREGISTRATION =         0;  // (<100000000) = preregistration.
BF.TURN_REGISTRATION    = 100000000;  // (100000000+) = registration.
BF.TURN_PICK_ZONE       = 200000000;  // (200000000+) = pick zone.
BF.TURN_PICK_CAPITAL    = 300000000;  // (300000000)  = pick capital.
BF.TURN_NORMAL          = 400000000;  // (400000000+) = normal turns.

// Human or Comp submitted turn:
BF.TURN_SOURCE_MANUAL  = 1;  // manually submitted turn.
BF.TURN_SOURCE_DEFAULT = 2;  // default turn generated for missing turn.
BF.TURN_SOURCE_COMP    = 3;  // bot or auto turn.

//============================= Replay Constants ===============================

// Replay Stages:  adjust                    0
//                 move or load or unload  1-8
//                 forces destroyed          9
//                 zone ownership changes   10
//                 aircraft landing         11
//                 crash/splash aircraft    12
//                 placement                13
BF.REPLAY_STAGE_ADJUST       =  0;
BF.REPLAY_STAGE_MOVE1        =  1;
BF.REPLAY_STAGE_MOVE2        =  2;
BF.REPLAY_STAGE_MOVE3        =  3;
BF.REPLAY_STAGE_MOVE4        =  4;
BF.REPLAY_STAGE_MOVE5        =  5;
BF.REPLAY_STAGE_MOVE6        =  6;
BF.REPLAY_STAGE_MOVE7        =  7;
BF.REPLAY_STAGE_MOVE8        =  8;
BF.REPLAY_STAGE_DESTROY      =  9;
BF.REPLAY_STAGE_ZONE_CHANGE  = 10;
BF.REPLAY_STAGE_LANDING      = 11;
BF.REPLAY_STAGE_CRASH_SPLASH = 12;
BF.REPLAY_STAGE_PLACEMENT    = 13;
BF.MAX_REPLAY_STAGES         = 14;  // see above

BF.REPLAY_STAGE_STRING = [
  'Adjust',
  'Move Phase 1', 'Move Phase 2', 'Move Phase 3', 'Move Phase 4',
  'Move Phase 5', 'Move Phase 6', 'Move Phase 7', 'Move Phase 8',
  'Casualties', 'Takeovers', 'Landing', 'Crash/Splash', 'Placement',
];

//============================= Player Constants ===============================

// Not including 0 player, so [0..30]:
BF.MAX_PLAYERS = 30;

// playerFlags bit values:
BF.PLAYER_FLAG_HUMAN    = 1;
BF.PLAYER_FLAG_COMPUTER = 2;

BF.PLAYER_STARTING_SCORE = 10000;         // Starting score value for each player.
BF.PLAYER_STARTING_MEMBERSHIP_LEVEL = 1;  // Basic member.

BF.PLAYER_MEMBERSHIP_NAME = ['Unknown', 'Basic', 'Premium', 'Extreme'];
BF.MEMBERSHIP_MAX_GAMES = [0, 3, 10, 30];

BF.PLAYER_RANK_TITLE = [
  'Private', 'Private 1st Class', 'Corporal', 'Sergeant', 'Staff Sergeant',
  'Sergeant 1st Class', 'Master Sergeant', 'First Sergeant', 'Sergeant Major', 'Command SGT Major',
  'Second Lieutenant', 'First Lieutenant', 'Captain', 'Major', 'Colonel',
  'Brigadier General', 'Major General', 'Lieutenant General', '4 Star General', '5 Star General'
];

BF.PLAYER_RANK_SCORE = [0, 9500, 9900, 10000, 10100, 10200, 10300, 10500, 11000, 12000];

BF.PLAYER_RANK_XP = [0, 25, 100, 250, 500, 1000, 2000, 5000, 10000, 20000];

BF.MAX_PLAYER_USER_NAME = 15;  // Max user name string length.
BF.MAX_PLAYER_SLOT_NAME = 24;  // Max user slot string length for scenarios.
BF.MAX_TEAM_NAME = 24;         // Max team name string length.

//=============================== User Constants ===============================

BF.USER_FLAG_GAME_ADMIN        = 1;
BF.USER_FLAG_BETA_FEATURES     = 2;
BF.USER_FLAG_EMAIL_NOTIFY_TURN = 4;


//======================== Victory Reason Constants ============================

// Bits set for why the game finished (game.victory.reason bits) =
BF.VICTORY_GAME_CANCELLED =  1;  // Game was cancelled by game admin.
BF.VICTORY_TURN_LIMIT =      2;  // Game maximum turns was reached.
BF.VICTORY_TIME_LIMIT =      4;  // Game maximum time was reached.
BF.VICTORY_AUTOPLAY_LIMIT =  8;  // All human players autoplayed consecutively too many times.
BF.VICTORY_NO_HUMANS_LEFT = 16;  // There are no human players left.
BF.VICTORY_CAPITALS =       32;  // Capitals Victory Condition was met.
BF.VICTORY_ZONES =          64;  // Nations Victory Condition was met.
BF.VICTORY_INCOME =        128;  // Income Victory Condition was met.
BF.VICTORY_CASH =          256;  // Cash Victory Condition was met.
BF.VICTORY_ELIMINATION =   512;  // Won by elimination of all opponents.


export default BF;
